import contract from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import modifiedOnChange from './modifiedOnChange.js'
import modifiedIframe from './modifiedIframe.js'
import modifiedOnInput from './modifiedOnInput.js'

export default contract({
  modifiedOnChange: array([
    modifiedOnChange
  ]),
  modifiedIframe: array([
    modifiedIframe
  ]),
  modifiedOnInput: array([
    modifiedOnInput
  ]),
})